import { apiFetch } from './client';

export const listCategories = (token) => apiFetch(token, '/categories');

export const createCategory = (token, payload) =>
  apiFetch(token, '/categories', { method: 'POST', body: JSON.stringify(payload) });

export const updateCategory = (token, categoryId, payload) =>
  apiFetch(token, `/categories/${categoryId}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const deleteCategory = (token, categoryId) =>
  apiFetch(token, `/categories/${categoryId}`, { method: 'DELETE' });
